  import Enum from './enum'

class Precision extends Enum
{
  constructor(value) {
    super(value);
  }
}

Precision.init({
  EXACTLY: true,
  NOT_WORSE: false
}, {
  EXACTLY: 'precision.exact',
  NOT_WORSE: 'precision.not-worse',
});

export default Precision;
